import React from "react";
import "../../../ui-styles/nodata/NoData.css";
import Button from "../../../lib/ui/buttons/Button";

const NoData = (props) => {
    const { fullSize } = props;
    const cls = `nodataBlock ${fullSize}`

    return (
        <div className={cls}>
            <div className="ndIconBox">
                {/* <img src="/images/icons/doc-advice.png" alt="icon" /> */}
                <img src={props.src} alt="icon" className={props.src && props.src === "/images/icons/doctor-default.png" ? "" : "invertPrimary"} />
            </div>
            <span className="nodataHdng">{props.Heading}</span>
            <span className="txtMd txtCenter">{props.label}</span>
            {props.btnAction &&
                <div className="nodataAction">
                    <Button
                        label={props.btnLabel}
                        type='primary'
                        size='md'
                        onClick={props.handleButton}
                    />
                </div>
            }
        </div>
    )
}

export default NoData;

// fullSize="flexOne"